import React from "react";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  RegistrationTableTypes,
  RegistrationStatuses,
  RegisWizardCloseActions,
} from "../../Helpers/LookUpValues";

export default function CloseRegistrationWizardModal(props) {
  const {
    modal,
    toggle,
    confirm,
    justCloseRegModal,
    regTableType,
    registrationRow,
    submitFormData,
    isFormValid,
    isOnQuestionsStep,
    setFormErrors,
  } = props;

  const handleModalClose = (btnVal) => {
    if (btnVal == RegisWizardCloseActions.JustClose) {
      justCloseRegModal();
    } else if (btnVal == RegisWizardCloseActions.SaveAndClose) {
      //setFormErrors({});
      confirm().confirmed(submitFormData, btnVal, setFormErrors);
    } else if (btnVal == RegisWizardCloseActions.DeleteRegis) {
      // Discard the unfinished registration, then close the wizard.
      //
      // The close matters. The branch this replaced called the service and stopped there, so a
      // member who cancelled was left sitting in the wizard for a registration that no longer
      // existed, over a list still showing it as In Progress. onClose both shuts the modal and
      // reloads the list, which is how the delete icon on My Registrations already behaves.
      props
        .deleteRegistration(registrationRow.id)
        .then((data) => {
          if (data && data.statusCode == 200) {
            justCloseRegModal();
          }
        })
        .catch(() => {
          // RegistrationsService has already told the user; leave the wizard open so the
          // registration is still in front of them.
        });
    }
  };
  return (
    <Modal
      centered={true}
      autoFocus={true}
      isOpen={modal}
      toggle={toggle}
      backdrop="static"
    >
      <ModalHeader toggle={toggle}>Leave this page without saving?</ModalHeader>
      <ModalBody>
        <div className="col-12 mb-4">
          <h6 className="mb-0">
            Anything you have entered on this registration will not be saved.
          </h6>
        </div>
      </ModalBody>
      <ModalFooter>
        {/*
          Split button, as it has always been: the discard action, with the alternatives behind
          the caret. Kept deliberately rather than flattened into separate buttons -- the only
          thing that was actually broken here was the test gating "Save And Close", which
          compared currentStep (a numeric index) against RegisWizardSteps.SecondStep (the string
          "secondStep"). That could never be true, so the dropdown was empty on every step and
          the registration administrator reported, correctly, that there was "no option for yes
          to save". The parent now passes isOnQuestionsStep, which it can compute because it is
          the only place that knows the step order.

          The main button is no longer labelled "No". It answered the old body text, "Are you
          want to Save the Information?"; under the heading Linda asked for, "No" would read as
          "no, do not leave" while still discarding and closing.
        */}
        <div class="btn-group">
          <button
            type="button"
            onClick={() => handleModalClose(RegisWizardCloseActions.JustClose)}
            class="btn btn-success"
            title="Close without saving anything you have entered."
          >
            Leave without saving
          </button>
          <button
            type="button"
            className="btn btn-success dropdown-toggle dropdown-toggle-split"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="sr-only">Toggle Dropdown</span>
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            {/* isFormValid && */}
            {isOnQuestionsStep && (
              <a
                class="dropdown-item"
                href="#"
                onClick={() =>
                  handleModalClose(RegisWizardCloseActions.SaveAndClose)
                }
              >
                Save And Close
              </a>
            )}
            {/*
              Delete, not Cancel. An In Progress row is a half-finished draft, and the agreed
              rule (MN-2086) is that drafts are deleted while cancelling is reserved for a
              member giving up a place they actually hold. Cancelling a draft filed a phantom
              cancellation against a registration that had never been completed.

              The gate reads regisStatusId, not statusId. This row comes from
              GetMyRegistrations, whose DTO carries RegisStatusId -- `.statusId` is undefined
              on it, so the test was never true and the item never rendered for anyone. Same
              class of mistake as the "Save And Close" gate above, which compared a numeric
              step index against the string "secondStep".

              The wider status rules -- Cancel for Pending Approval, Registered and Waitlist,
              each with its own cutoff -- are MN-2086 and belong on that branch. This only puts
              the right verb on the status that is already handled here.
            */}
            {regTableType == RegistrationTableTypes.MyRegistrations &&
              registrationRow &&
              registrationRow.regisStatusId == RegistrationStatuses.InProgress && (
                <a
                  class="dropdown-item"
                  href="#"
                  onClick={() =>
                    handleModalClose(RegisWizardCloseActions.DeleteRegis)
                  }
                >
                  Delete Registration
                </a>
              )}
          </div>
        </div>

        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
